const Contact=()=>{
      return(
          <div> 
           <h1>contact</h1>
           <h1>this is contact us page</h1>
           </div>
      )
}
export default Contact;